import React, { FC } from 'react';
import { Skeleton } from 'src/common';
import { usePreviewTabState } from 'src/models/procurements/hooks';
import { ActivePreviewTab } from 'src/models/procurements/types';
import PreviewHeader from './Header';
import PreviewNav from './Nav';
import PreviewEmail from './Email';
import styles from './index.module.scss';
import { useActiveInboxEmail } from 'src/models/callOffs/hooks';

export const CallOfPreview: FC = () => {
  const { loading } = useActiveInboxEmail();
  const [activeTab] = usePreviewTabState();

  return (
    <>
      <div className={styles.header}>
        {loading ? (
          <Skeleton loading active />
        ) : (
          <>
            <PreviewHeader />
            <PreviewNav />
          </>
        )}
      </div>
      <div className={styles.content}>
        {loading ? <Skeleton loading active /> : <>{activeTab === ActivePreviewTab.Email && <PreviewEmail />}</>}
      </div>
    </>
  );
};

export default CallOfPreview;
